module.exports = __webpack_public_path__ + "static/fonts/Metric-Black.28acf3f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metric/Metric-Black.woff
// module id = Q4EE
// module chunks = 88